import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.p-accordion {
    display: grid;
    gap: ${dt('appAccordion.panelGap')};
}`;
